import React from 'react';
import uuid from 'uuid/v4';
var createUuidGenerator = function createUuidGenerator(_ref) {
  var _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'nw-aria' : _ref$prefix;
  return function generateRandomId() {
    return "".concat(prefix, "-").concat(uuid());
  };
};
export var defaultContext = createUuidGenerator({});
var IdContext = /*#__PURE__*/React.createContext(createUuidGenerator({}));
export default IdContext;